import { useCallback } from 'react';
import { toastService } from 'components/molecules/toast';
import { useTranslate } from 'hooks/use-translation';

const useToastService = () => {
  const translate = useTranslate();

  return useCallback(
    (dashboardName, msg, success) => {
      const title = success ? 'success' : 'failure';
      const service = toastService({
        title: translate(title),
        message: translate(msg, {
          name: dashboardName,
        }),
      });

      if (success) {
        service.success();
      } else {
        service.error();
      }
    },
    [translate],
  );
};

type DashboardToastMessage = {
  showCreateMessage: (dashboardName: string, success?: boolean) => void;
  showEditMessage: (dashboardName: string, success?: boolean) => void;
  showDeletedMessage: (dashboardName: string, success?: boolean) => void;
  showDuplicateMessage: (dashboardName: string, success?: boolean) => void;
};

export const useDashboardToastMessage = (): DashboardToastMessage => {
  const toast = useToastService();
  const showCreateMessage = useCallback(
    (name, success = true) => {
      const msg = success
        ? 'dashboard.notify.create.success'
        : 'dashboard.notify.create.error';

      toast(name, msg, success);
    },
    [toast],
  );

  const showEditMessage = useCallback(
    (name, success = true) => {
      const msg = success
        ? 'dashboard.notify.edit.success'
        : 'dashboard.notify.edit.error';

      toast(name, msg, success);
    },
    [toast],
  );

  const showDeletedMessage = useCallback(
    (name, success = true) => {
      const msg = success
        ? 'dashboard.notify.delete.success'
        : 'dashboard.notify.delete.error';

      toast(name, msg, success);
    },
    [toast],
  );

  const showDuplicateMessage = useCallback(
    (name, success = true) => {
      const msg = success
        ? 'dashboard.notify.duplicate.success'
        : 'dashboard.notify.duplicate.error';

      toast(name, msg, success);
    },
    [toast],
  );

  return {
    showCreateMessage,
    showEditMessage,
    showDeletedMessage,
    showDuplicateMessage,
  };
};
